import { render, staticRenderFns } from "./WfConsumerUserModal.vue?vue&type=template&id=8089f43a&scoped=true&"
import script from "./WfConsumerUserModal.vue?vue&type=script&lang=js&"
export * from "./WfConsumerUserModal.vue?vue&type=script&lang=js&"
import style0 from "./WfConsumerUserModal.vue?vue&type=style&index=0&id=8089f43a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8089f43a",
  null
  
)

export default component.exports